(() => {
  if (window.curaFootGenderSizePickerInitialized) return;
  window.curaFootGenderSizePickerInitialized = true;

  const root = document.documentElement;
  const attribute = 'data-curafoot-size-gender';
  const selector = '[data-curafoot-gender-button]';

  const currentGender = () => root.getAttribute(attribute) === 'women' ? 'women' : 'men';

  const syncButtons = () => {
    const gender = currentGender();
    document.querySelectorAll(selector).forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.curafootGenderButton === gender));
    });
  };

  const setGender = (gender) => {
    root.setAttribute(attribute, gender === 'women' ? 'women' : 'men');
    syncButtons();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(selector);
    if (!button) return;
    setGender(button.dataset.curafootGenderButton);
  });

  document.addEventListener('shopify:section:load', syncButtons);

  const observer = new MutationObserver((records) => {
    if (records.some((record) => Array.from(record.addedNodes).some((node) =>
      node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))
    ))) syncButtons();
  });

  const start = () => {
    setGender(currentGender());
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();


(() => {
  if (window.curaFootSyncElixirVariant) return;
  window.curaFootSyncElixirVariant = true;

  const pickerSelector = '.simple-variant-picker .curafoot-size-picker';
  const radioSelector = '.simple-variant-picker__radio[data-option-position]';

  const syncVariant = (radio) => {
    const picker = radio.closest('.simple-variant-picker');
    const sizePicker = radio.closest('.curafoot-size-picker');
    if (!picker || !sizePicker) return;

    const json = picker.querySelector('.simple-variant-picker__variants-json');
    if (!json) return;

    let variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (_error) {
      return;
    }

    const selected = [];
    picker.querySelectorAll(radioSelector + ':checked').forEach((input) => {
      selected[Number(input.dataset.optionPosition) - 1] = input.value;
    });

    const variant = variants.find((candidate) =>
      candidate.options.every((value, index) => selected[index] === value)
    );
    if (!variant) return;

    const variantIds = new Set(variants.map((candidate) => String(candidate.id)));
    const form = radio.form;

    if (form) {
      form.querySelectorAll('input[name="id"], input[name="product-id"], input[name^="items["][name$="[id]"]').forEach((input) => {
        if (
          input.name === 'id' ||
          input.name === 'product-id' ||
          variantIds.has(String(input.value))
        ) {
          input.value = String(variant.id);
        }
      });
    }

    document.querySelectorAll('#sticky-variant-id').forEach((input) => {
      if (variantIds.has(String(input.value))) input.value = String(variant.id);
    });

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    document.dispatchEvent(new CustomEvent('simple-variant-picker:variantChange', {
      detail: { variant }
    }));
  };

  document.addEventListener('change', (event) => {
    const radio = event.target.closest?.(radioSelector);
    if (radio?.closest(pickerSelector)) syncVariant(radio);
  }, true);
})();
